import { useEffect,useState, useRef } from "react"

export function useBlcNavScroll() {
  const [blcNavbg, setBlcNabBg] = useState(false)
  const [textColor,setTextColor] = useState(false)
  const navRef = useRef()
  const colorRef = useRef();
  navRef.current = blcNavbg;
  colorRef.current = textColor;
  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY >50
      if (navRef.current !== show && colorRef.current !== show) {
        setBlcNabBg(show)
        setTextColor(show);
      }
    }
    document.addEventListener('scroll', handleScroll)
    return () => {
      document.removeEventListener('scroll', handleScroll)
    }
  }, [blcNavbg,textColor])

  return[blcNavbg,setBlcNabBg,textColor,setTextColor]
    
  }


  export function  bottomTotop() {
    window.scrollTo({
      top:0,
      behavior:'smooth'
  })
    
    
  }